import FJUtil from '@src/util/FJUtil';
import LogoIcon from '../../assets/logo.svg?react';
import styles from './FJHeader.module.less';

const FJHeader = () => {
    const onLogoClick = () => {
        window.location.href = FJUtil.getCurrentUrl() + 'editor/';
    };
    return (
        <div className={styles.header_panel}>
            <div className={styles.logo_box} onClick={onLogoClick}>
                <LogoIcon />
            </div>
        </div>
    );
};

export default FJHeader;
